import {
  deleteApiV1ThreeLetterCodePartnerAdminsUsersUserId,
  getPostApiV1ThreeLetterCodePartnerAdminsUsersMutationKey,
} from '@fukuri-admins/apis/client/gen/endpoints';
import { useMutation } from '@fukuri-admins/hooks/common';
import { AxiosError } from 'axios';
import type { Key } from 'swr';

/**
 * パートナー管理者向け利用者削除フック
 *
 * - trigger 時に userId(number) を受け取り、String 変換して API に渡す
 * - mutation key は安定キー（POST key）を使用。per-id キーにすると行ごとにキーが変わるため
 *
 * @param threeLetterCode - パートナーの 3 文字コード
 * @param options - コールバックオプション
 */
export const useDeletePartnerAdminsUser = (
  threeLetterCode: string,
  options?: {
    onSuccess?: () => void;
    onError?: (error: AxiosError<{ errors?: string[] }>) => void;
  }
) => {
  return useMutation(
    getPostApiV1ThreeLetterCodePartnerAdminsUsersMutationKey(threeLetterCode),
    (_: Key, { arg }: { arg: number }) =>
      deleteApiV1ThreeLetterCodePartnerAdminsUsersUserId(threeLetterCode, String(arg)),
    options
  );
};
